import React, { useContext, useState } from 'react'
import { Search } from 'lucide-react';
import { Context } from 'Context/Context';
import { useNavigate } from 'react-router-dom';
import { profilePanelItems, profNotifyPanelItems, searchNotificationsApi, searchWithCaseNumberApi } from 'Constants';
import TestModal from 'Modals/TestModal';
import NoCaseFoundModal from 'Modals/NoCaseFoundModal';
import NotificationsModal from 'Modals/NotificationsModal';

function SearchContentNotifications({attorney, userId}) {
    const {makeApiCallFunc} = useContext(Context);
    const [showModal, setShowModal] = useState(false);
    const [caseNumber, setCaseNumber] = useState("");
    const [notificationsList, setNotificationsList] = useState([]);
    const [query, setQuery] = useState('');
    // const navigate = useNavigate();
    const handleSearchSubmit = (value) => {
        setCaseNumber(value);
        makeApiCallFunc(searchNotificationsApi, {caseNumber : value, userId}, ({data}) => {
               setNotificationsList(data);
               console.log("Notifications data:", data);
                setShowModal(true);
        }, (error) => console.log(error));
       
    }
  return (
        <>
        {
        showModal &&
        <NotificationsModal notificationsList={notificationsList} caseNumber={caseNumber} uploadNew={showModal} onClose={()=>
        {
          profNotifyPanelItems[0].count = 0;
          profNotifyPanelItems[1].count = 0;
          setShowModal(false)}
         } attorney={attorney}/>
        }
        <div className='flex items-center bg-white font-plexsans' style={{ width: '240px', maxWidth: '100%', height: '36px', border: '1px solid rgba(20,33,61,.15)', borderRadius: '5px', padding: '0 12px', gap: '8px' }}>
          <Search size={14} strokeWidth={2} color='rgba(20,33,61,.45)' className='flex-none' />
          <input
            type='text'
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && query.trim()) handleSearchSubmit(query.trim()); }}
            placeholder='Search by case ID'
            className='flex-1 min-w-0 bg-transparent outline-none text-navy placeholder:text-[rgba(20,33,61,0.4)]'
            style={{ fontSize: '13px' }}
          />
        </div>
        </>
  )
}

export default SearchContentNotifications